module.exports = __webpack_public_path__ + "img/画板 1 拷贝.f7fc9e51.jpg";